import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { UL, LI } from '../../../AbstractElements';
import { BuyNow } from '../../../Constant';

const ColorSelector = () => {
  const [active, setActive] = useState('1');
  return (
    <Fragment>
      <div className='color-selector'>
        <UL className='simple-list d-flex flex-row'>
          <LI className={`white rounded-0 ${active === '1' && 'active'}`} onClick={() => setActive('1')}></LI>&nbsp;
          <LI className={`bg-primary ${active === '2' && 'active'}`} onClick={() => setActive('2')}></LI>&nbsp;
          <LI className={`bg-secondary ${active === '3' && 'active'}`} onClick={() => setActive('3')}></LI>&nbsp;
          <LI className={`bg-success ${active === '4' && 'active'}`} onClick={() => setActive('4')}></LI>&nbsp;
          <LI className={`bg-warning ${active === '5' && 'active'}`} onClick={() => setActive('5')}></LI>&nbsp;
          <LI className={`bg-danger rounded-0 ${active === '6' && 'active'}`} onClick={() => setActive('6')}></LI>&nbsp;
        </UL>
      </div>
      <Link className='btn btn-secondary' to={`${process.env.PUBLIC_URL}/ecommerce/checkout`}>
        <i className='fa fa-shopping-cart me-2'></i>
        {BuyNow}
      </Link>
    </Fragment>
  );
};

export default ColorSelector;
